import styled from '@emotion/styled';

const SelectorWrapper = styled('section')({
  marginBottom: 12,
  display: 'flex',
  alignItems: 'center',
  label: {
    marginRight: 12,
    fontWeight: 500,
  },
  '.MuiSelect-root': {
    marginRight: 8,
    width: 256,
  },
});

export default SelectorWrapper;
